import styles from './Services.module.scss'
import { motion } from "framer-motion"

const titleAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .3 }
    }
}


const Services = ({isOpen}) => {

    return (
        <motion.section 
        className={styles.main}
        id='preimushchestva' 
        initial='hidden'
        whileInView='visible'
        viewport={{amount: 0.05, once: true}}
        >  
        <div className={styles.container}>
        <motion.h2 className={styles.title} variants={titleAnimation}>Комплекс услуг подготовки полного пакета документов для легальной работы ВКС в России</motion.h2>
        <motion.h3 className={styles.subtitle}  variants={titleAnimation}>Высококвалифицированные специалисты (ВКС) могут получить разрешение на работу в России сроком до 3 лет.</motion.h3>
        <motion.ul className={styles.list}>
            <li className={styles.item}>
                <p className={styles.text_big}>Срок оформления</p>
                <p className={styles.text}>14 рабочих дней</p>
            </li>
            <li className={styles.item}>
                <p className={styles.text_big}>Должность</p>
                <p className={styles.text}>Любая</p>
            </li>
            <li className={styles.item}>
                <p className={styles.text_big}>Владение русским языком</p>
                <p className={styles.text}>Не&nbsp;требуется</p>
            </li>
            <li className={styles.item}>
                <p className={styles.text_big}>Количество регионов осуществления трудовой деятельности</p>
                <p className={styles.text}>Несколько</p>
            </li>
            <li className={styles.item}>
                <p className={styles.text_big}>Возможность оформления сопровождающих членов семьи</p>
                <p className={styles.text}>Есть</p>
            </li>
            <li className={styles.item}>
                <p className={styles.text_big}>Упрощенный порядок получения ВНЖ</p>
                <p className={styles.text}>Есть</p>
            </li>
            <li className={styles.item}>
                <p className={styles.text_big}>Стоимость оформления от</p>
                <p className={styles.text}><span>35&nbsp;000₽</span></p>
            </li>       
        </motion.ul>
        </div>   
    </motion.section>
    )
}

export default Services